import request from '@/utils/request'

let Special_serviceApi = {

  /*特约服务列表*/
  list(data) {
    return request._post('/shop/plus.special_service.Index/index', data);
},
/*添加特约服务*/
add(data) {
    return request._post('/shop/plus.special_service.Index/add', data);
},
/*修改特约服务*/
edit(data) {
    return request._post('/shop/plus.special_service.Index/edit', data);
},
/*删除特约服务*/
del(data) {
    return request._post('/shop/plus.special_service.Index/del', data);
},
/*特约服务详情*/
detail(data) {
  return request._post('/shop/plus.special_service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.special_service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.special_service.Setting/getSetting', data, errorback);
    },
}
export default Special_serviceApi;



// WEBPACK FOOTER //
// ./src/api/special_service.js